'use client'

import { NetworkDisplayView } from '~/components/component-library/NetworkDisplay/components/NetworkDisplayView'
import { NetworkDisplayProps } from '~/components/component-library/NetworkDisplay/types'
import { useRelayNetworkInfo } from '~/hooks/useRelayNetworks'
import { getChainLabel } from '~/utils/chainLabels'

export type {
  NetworkDisplayLayout,
  NetworkDisplayProps,
} from '~/components/component-library/NetworkDisplay/types'

export const NetworkDisplay = ({
  chainId,
  layout,
  size = 'base',
  highlightText,
}: NetworkDisplayProps) => {
  // One relay lookup feeds both the name and the logo fallback, so a chain
  // outside the registry resolves the same way in both.
  const relayNetworkInfo = useRelayNetworkInfo(chainId)
  const label = getChainLabel(chainId, { relayNetwork: relayNetworkInfo })

  return (
    <NetworkDisplayView
      chainId={chainId}
      layout={layout}
      size={size}
      label={label}
      relayNetworkInfo={relayNetworkInfo}
      highlightText={highlightText}
    />
  )
}
